import { MapDatasetEnriched, Widget, WidgetType } from '../types'
import { isCategoryWidgetValid } from 'features/builder/model/widgets/categoryWidget'
import { isPieWidgetValid } from 'features/builder/model/widgets/pieWidget'
import { isTimeSeriesWidgetValid } from 'features/builder/model/widgets/timeSeriesWidget'
import { isFormulaWidgetValid } from '../ui/KeplerGl/SidePanel/FilterManager/WidgetsConfigurator/WidgetForm/models/useWidgetFormulaModel'
import { isHistogramWidgetValid } from '../ui/KeplerGl/SidePanel/FilterManager/WidgetsConfigurator/WidgetForm/models/useWidgetHistogramModel'
import { isRangeWidgetValid } from '../ui/KeplerGl/SidePanel/FilterManager/WidgetsConfigurator/WidgetForm/models/useWidgetRangeModel'
import { isTableWidgetValid } from '../ui/KeplerGl/SidePanel/FilterManager/WidgetsConfigurator/WidgetForm/models/useWidgetTableModel'

export function isWidgetValid(widget: Widget, { source }: { source: MapDatasetEnriched }): boolean {
  switch (widget.type) {
    case WidgetType.FORMULA:
      return isFormulaWidgetValid(widget, { source })
    case WidgetType.CATEGORY:
      return isCategoryWidgetValid(widget, { source })
    case WidgetType.RANGE:
      return isRangeWidgetValid(widget, { source })
    case WidgetType.HISTOGRAM:
      return isHistogramWidgetValid(widget, { source })
    case WidgetType.TIMESERIES:
      return isTimeSeriesWidgetValid(widget, { source })
    case WidgetType.PIE:
      return isPieWidgetValid(widget, { source })
    case WidgetType.TABLE:
      return isTableWidgetValid(widget, { source })
  }
}
